import { useShopTime } from '../../../../Timezone/providers/ShopTimeProvider';
import { useAnalyticsParams } from '../modules/AnalyticsParams/hooks/useAnalyticsParams';
export const useAnalyticsCardLegend = () => {
    const { formatInShopTime, toShopTime } = useShopTime();
    const { dateRange } = useAnalyticsParams();
    const [startDate, endDate] = dateRange.value.dates;
    const shopStartDate = toShopTime(startDate);
    const shopEndDate = toShopTime(endDate);
    const isSameDay = shopStartDate.format('YYYY-MM-DD') === shopEndDate.format('YYYY-MM-DD');
    if (isSameDay) {
        return formatInShopTime(startDate, 'MMM D, YYYY');
    }
    const isSameYear = shopStartDate.format('YYYY') === shopEndDate.format('YYYY');
    if (isSameYear) {
        const startFormatted = formatInShopTime(startDate, 'MMM D');
        const endFormatted = formatInShopTime(endDate, 'MMM D, YYYY');
        return `${startFormatted} - ${endFormatted}`;
    }
    const startFormatted = formatInShopTime(startDate, 'MMM D, YYYY');
    const endFormatted = formatInShopTime(endDate, 'MMM D, YYYY');
    return `${startFormatted} - ${endFormatted}`;
};
